import React, { useState, useEffect, useContext, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Card } from "primereact/card";
import { Timeline } from "primereact/timeline";
import "./TimelineDemo.css"; // Đảm bảo rằng CSS của bạn được nhập đúng
import ModalDv from "./ModalLocation";
import { Button } from "primereact/button";
import {
    getTeamProgress,
    resetTeamProgress,
    resetTeamChildren,
    getDViFull,
} from "../../store/order/slice";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { formatDate2 } from "../../components/utils";
import { Image } from "primereact/image";
import "../../assets/scss/theme-base/Intersection.css";
import { generatePdf } from "./generatePdf";
import AddLocationPopup from "./AddLocationPopup";
import { setDataNull2 } from "../../store/teams/slice";
import ModalAssignment2 from "./ModalAssignment2";
import { useNavigate } from "react-router-dom";
import FormatDate from "../Report/FormatDate";
import { DataContext } from "../../contexts/data/DataProvider";
import { clearDataExcel, getPdfDataNew } from "../../store/Excels/slice";
import { downloadFile } from "../../ultis/downloadPdf";
import { Toast } from "primereact/toast";
import { formatDate } from "./ModalShowPlan";
import { colorIntersection } from "../../constants/color";
import IntersectionChildren from "./intersectionChildren";

const Intersection = ({ visible, onHide, factoryCode, rowData, productId }) => {
    const dispatch = useDispatch();
    const { prefix } = useContext(DataContext);
    const isGuest = localStorage.getItem("isGuest");
    const isPm = localStorage.getItem("isPm");
    const toast = useRef(null);

    const [visibleModalDv, setVisibleModalDv] = useState(false);
    const [intersection1Modal, setOpenIntersection1Modal] = useState(false);
    const [selectedEventName, setSelectedEventName] = useState("");
    const [teamGroupId, setTeamGroupId] = useState("");
    const [remaining, setRemaining] = useState(0);
    const [visibleAddLocationPopup, setVisibleAddLocationPopup] =
        useState(false);
    useEffect(() => {
        if (rowData?.totalActualDelivery) {
            setRemaining(rowData.quantity - rowData.totalActualDelivery);
        } else {
            setRemaining(rowData?.quantity);
        }
    }, [rowData]);

    const [showAssignmentModal, setShowAssignmentModal] = useState(false);
    const {
        events,
        dataDVi,
        addQrTeamData,
        deleteSuccess,
        updateSuccess,
        pdfData,
    } = useSelector(
        (state) => ({
            events: state.Production.dataTeamProgress?.data?.items,
            dataDVi: state.Production.dataDVi,
            addQrTeamData: state.Teams.addQrTeamData,
            deleteSuccess: state.Product.deleteLocation.data,
            updateSuccess: state.Product.updateLocation.data,
            pdfData: state.Excel.pdfData,
        }),
        shallowEqual
    );

    const navigate = useNavigate();

    if (pdfData && pdfData?.url === null) {
        toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "Không có dữ liệu để in",
            life: 5000,
        });
        dispatch(clearDataExcel());
    }

    if (pdfData && pdfData.url) {
        downloadFile(pdfData.url);
        dispatch(clearDataExcel());
    }

    const goBackIfImport = () => {
        const previousPath = document.referrer;
        if (previousPath.includes("/import")) {
            navigate(-1);
        } else {
            // console.log("Trang trước không phải là '/import', giữ nguyên");
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (factoryCode) {
                dispatch(getTeamProgress({ id: factoryCode }));
            }
        };
        fetchData();
    }, [dispatch, factoryCode, deleteSuccess, updateSuccess, addQrTeamData]);

    useEffect(() => {
        if (addQrTeamData) {
            dispatch(getTeamProgress({ id: factoryCode }));
            dispatch(setDataNull2());
        }
    }, [dispatch, addQrTeamData, factoryCode]);

    const handlePrintPdf = async () => {
        // if (factoryCode) {
        //     dispatch(getDViFull({ id: factoryCode }));
        // }

        if (rowData && rowData?.id) {
            dispatch(
                getPdfDataNew({
                    type: "statistic-timeline",
                    productIds: JSON.stringify([rowData?.id]),
                })
            );
        }
    };

    // useEffect(() => {
    //     if (dataDVi && dataDVi.data && rowData) {
    //         generatePdf(
    //             dataDVi,
    //             rowData?.Building?.name,
    //             rowData?.categoryName,
    //             rowData?.factoryCode,
    //             FormatDate(rowData?.intendFinishDate),
    //             rowData?.color
    //         );
    //     }
    // }, [dataDVi, rowData]);

    const customizedContent = (item) => {
        const handleDetailClick = (item) => {
            // setSelectedEventName(eventName);
            // setVisibleModalDv(true);
            setOpenIntersection1Modal(true);
            setTeamGroupId(item.teamId);
        };

        return (
            <Card
                title={
                    <div
                        style={{
                            backgroundColor: item?.Productions[0]?.status
                                ? colorIntersection.find(
                                      (color) =>
                                          color.index ===
                                          item?.Productions[0]?.index
                                  )?.color
                                : "transparent",
                            color: item?.Productions[0]?.status ? "white" : "",
                            width: "fit-content",
                            padding: "2px 8px",
                            borderRadius: "3px",
                        }}
                    >
                        {item.name}
                    </div>
                }
            >
                <Toast ref={toast} />
                {item.Productions.map((production, index) => {
                    const timeStart = production.timeStart;
                    const timeEnd = production.timeEnd;

                    return (
                        <div
                            key={index}
                            className="flex align-items-center justify-content-between"
                        >
                            <div style={{ width: "400px" }}>
                                {item.name !== "Tiếp nhận đơn hàng" && (
                                    <div className="flex pb-3 align-items-center">
                                        <p>
                                            Kế hoạch hoàn thành:{" "}
                                            {formatDate(production?.startDate)}{" "}
                                            - {formatDate(production?.endDate)}
                                        </p>
                                        {production?.status && (
                                            <span
                                                style={{
                                                    padding: "2px",
                                                    backgroundColor:
                                                        production?.status ===
                                                        "Trễ tiến độ"
                                                            ? "red"
                                                            : "#ffd966",
                                                    color: "white",
                                                    borderRadius: "3px",
                                                    marginLeft: "2px",
                                                }}
                                            >
                                                {production?.status}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <p>
                                    {item === events[events.length - 1]
                                        ? `Thời gian bắt đầu: ${formatDate2(
                                              timeStart
                                          )}`
                                        : `Thời gian: ${
                                              timeEnd
                                                  ? `${formatDate2(
                                                        timeStart
                                                    )} - ${formatDate2(
                                                        timeEnd
                                                    )}`
                                                  : `${formatDate2(
                                                        timeStart
                                                    )} ${
                                                        timeStart
                                                            ? "- đang làm"
                                                            : ""
                                                    }`
                                          }`}
                                </p>
                                <p className="pt-3">
                                    Số lượng: {production?.quantityMade}
                                </p>
                                {/* <p className="pt-3">
                                Còn lại: {parseInt(remaining) || 0}
                            </p> */}

                                <p className="mt-2">{production.note}</p>
                            </div>
                            <div>
                                {production.images && (
                                    <div className="image-container pt-3">
                                        {production.images.map(
                                            (image, imgIndex) => (
                                                <Image
                                                    key={imgIndex}
                                                    src={image}
                                                    height="50"
                                                    width="50"
                                                    alt={item.name}
                                                    preview
                                                />
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                })}
                {item !== events[events?.length - 1] &&
                    ((isGuest?.toString() === "false" &&
                        isPm?.toString() === "false") ||
                        (!isGuest && !isPm)) && (
                        <div className="flex">
                            <p
                                className="text-primary font-bold cursor-pointer pt-2"
                                onClick={() => handleDetailClick(item)}
                            >
                                Xem tổ đội
                            </p>
                        </div>
                    )}
            </Card>
        );
    };

    const handleModalDvHide = () => {
        setVisibleModalDv(false);
        dispatch(resetTeamChildren());
    };

    const customizedMarker = (item) => {
        return (
            <span
                className="flex w-2rem h-2rem align-items-center justify-content-center text-white border-circle z-1 shadow-1"
                style={{ backgroundColor: "green" }}
            >
                <i className={item.icon}></i>
            </span>
        );
    };

    const handleAddLocationClick = () => {
        setVisibleAddLocationPopup(true);
    };
    const reversedEvents = Array.isArray(events) ? [...events] : [];
    const title = (color) => {
        if (color) {
            if (color === "#ff0000") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Trễ tiến độ
                    </div>
                );
            }
            if (color === "#ff5050") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Đúng ngày giao
                    </div>
                );
            }
            if (color === "#ffff00") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Gần giao dưới 3 ngày
                    </div>
                );
            }
            if (color === "#ffd966") {
                return (
                    <div
                        style={{
                            backgroundColor: color,
                            padding: "4px 8px",
                            borderRadius: "5px",
                        }}
                    >
                        Gần giao dưới 1 tuần
                    </div>
                );
            }
        } else {
            return "";
        }
    };

    return (
        <>
            <Dialog
                visible={visible}
                onHide={() => {
                    dispatch(resetTeamProgress());
                    onHide();
                    goBackIfImport();
                }}
                footer={
                    <div className="flex justify-content-between">
                        {((isGuest?.toString() === "false" &&
                            isPm?.toString() === "false") ||
                            (!isGuest && !isPm)) && (
                            <Button
                                label="Thêm định vị"
                                type="button"
                                onClick={handleAddLocationClick}
                            />
                        )}
                        <Button
                            label="Phân công sản xuất"
                            onClick={() => setShowAssignmentModal(true)}
                        />
                        <Button
                            label="In PDF"
                            icon="pi pi-print"
                            severity="danger"
                            size="small"
                            outlined
                            onClick={handlePrintPdf}
                        />
                    </div>
                }
                className="responsive-dialog"
                header={
                    <div className="flex align-items-center justify-content-center text-2xl">
                        DỰ ÁN: {rowData?.Building?.name}
                    </div>
                }
                modal
                style={{
                    width: "50%",
                    height: "90%",
                }}
            >
                <>
                    <div className="text-xl font-semibold ml-8">
                        <div>Tên hạng mục: {rowData?.categoryName}</div>
                        <div className="mt-2">
                            Mã nhà máy: {rowData?.factoryCode}
                        </div>
                        <div className="flex align-items-center mt-2">
                            Kế hoạch hoàn thành:{" "}
                            {FormatDate(rowData?.intendFinishDate)}{" "}
                            <span className="ml-2">
                                {title(rowData?.color)}
                            </span>
                        </div>
                    </div>
                    <div className="card">
                        <Timeline
                            value={reversedEvents}
                            align="alternate"
                            className="customized-timeline"
                            marker={customizedMarker}
                            content={customizedContent}
                        />
                    </div>
                </>
                <ModalDv
                    visible={visibleModalDv}
                    onHide={handleModalDvHide}
                    factoryCode={factoryCode}
                    name={selectedEventName}
                />
            </Dialog>
            {visibleAddLocationPopup && (
                <AddLocationPopup
                    factoryCode={factoryCode}
                    visible={visibleAddLocationPopup}
                    onHide={() => setVisibleAddLocationPopup(false)}
                    remaining={remaining}
                    quantity={rowData?.quantity}
                    unit={rowData?.unit}
                />
            )}
            <ModalAssignment2
                isShow={showAssignmentModal}
                onHide={() => setShowAssignmentModal(false)}
                factoryCode={factoryCode}
                rowData={rowData}
                productId={productId}
            />
            <IntersectionChildren
                visible={intersection1Modal}
                onHide={() => setOpenIntersection1Modal(false)}
                teamGroupId={teamGroupId}
                factoryCode={factoryCode}
                rowData={rowData}
                productId={productId}
            />
        </>
    );
};

export default Intersection;
